import React, { useState, useEffect } from 'react';
import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { TitlePage } from '@src/@styles/styles.global';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import IR from '@src/Pages/Private/Cliente/Admin/TiposFormasContribuicao/IR';

const FormasContribuicao: React.FC = () => {

  const [status, setStatus] = useState('');
  const [openIR, setOpenIR] = useState(false);

  useEffect(() => {
    window.document.title = 'CRM - Formas contribuições';
  }, []);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Formas de contribuições</TitlePage>
      </Grid>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Imposto de renda' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Imposto de renda'), setOpenIR(true))}
          >
            Imposto de renda
          </ButtonComponent>
        </Grid>

        <InvisibleContent visible={openIR === true}>
          <IR />
        </InvisibleContent>

      </Grid>
    </Grid>
  );
};

export default FormasContribuicao;
